export default __webpack_public_path__ + "static/media/faq.f9cf9012.jpg";